import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=461b51c4&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=461b51c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b51c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461b51c4')) {
      api.createRecord('461b51c4', component.options)
    } else {
      api.reload('461b51c4', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=461b51c4&scoped=true&", function () {
      api.rerender('461b51c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xda6ljlxhAjN/JS/comp/GuestBox.vue"
export default component.exports